<template>
  <bk-view class="view-eInvoiceOrderInfo">

    <bk-view class="view-title">
      <bk-title lang-code="e_invoice_text_billSummary"></bk-title>

      <bk-button :icon="showMoreFlag ? 'icon-shangjiantou' : 'icon-xiajiantou'" class="btn-more"
                 :class="[showMoreFlag ? 'show' : '']" type="icon" @click="showMoreFlag=!showMoreFlag"></bk-button>
    </bk-view>

    <bk-view class="view-baseInfo">

      <bk-view class="view-name">
        {{ orderInfo.compName || '门店名称' }}
      </bk-view>
      <bk-view class="view-flex">
        <bk-view class="view-orderId">
          No.{{ orderInfo.billNo }}
        </bk-view>
        <bk-price :unit-text="showPriceUnit" :value="amountInfo.totalAmt"></bk-price>
      </bk-view>

      <bk-view class="view-date">
        {{ orderInfo.billDate }}
      </bk-view>

    </bk-view>

    <bk-view v-if="showMoreFlag" class="view-content">

      <bk-view class="view-saleItems">
        <bk-view class="view-contentItem" v-for="item in orderInfo.contentList">

          <bk-view class="view-name">
            <span class="span-cnt">x{{item.quantity}}</span>{{item.name}}
          </bk-view>

          <bk-view class="view-priceInfo">
            <bk-view v-if="item.price>0" class="view-price">
<!--              lang-code_label="e_invoice_text_standUnitPrice"-->
              <bk-price :unit-text="showPriceUnit" :value="item.price"></bk-price>
            </bk-view>
            <bk-view class="view-payPrice">
              <bk-price v-if="item.dkFlag" :value="item.payTimes || 1">
                {{ $bk_getTextWithLangCode('userInfo_paymentDetail_deduction') }}
              </bk-price>

              <bk-price lang-code_label="e_invoice_text_paid" v-else :unit-text="showPriceUnit" :value="item.payAmtText"></bk-price>
            </bk-view>
          </bk-view>

        </bk-view>
      </bk-view>


      <bk-view class="view-amountInfo">

        <bk-view>
          <bk-view class="view-label"><bk-lang code="userInfo_paymentDetail_subtotal"></bk-lang></bk-view>
          <bk-price :unit-text="showPriceUnit" :value="amountInfo.subtotal"></bk-price>
        </bk-view>

        <bk-view>
          <bk-view class="view-label"><bk-lang code="userInfo_paymentDetail_taxes"></bk-lang></bk-view>
          <bk-price :unit-text="showPriceUnit" :value="amountInfo.taxes"></bk-price>
        </bk-view>

        <bk-view class="view-total">
          <bk-view class="view-label"><bk-lang code="userInfo_paymentDetail_total"></bk-lang></bk-view>
          <bk-price :unit-text="showPriceUnit" :value="amountInfo.totalAmt"></bk-price>
        </bk-view>
      </bk-view>

      <bk-view class="view-payment">

        <bk-view class="view-title">
          <bk-title lang-code="e_invoice_text_paymentSummary"></bk-title>
        </bk-view>

        <bk-view
            v-for="(item, index) in showPaymentList"
            class="view-payItem"
        >
          <bk-view class="view-label">
            {{ item.showName }}
          </bk-view>

          <bk-price v-if="item.dkFlag" unit-text="" :value="item.payTimes">
            {{ $bk_getTextWithLangCode('e_invoice_text_deduction') }}
          </bk-price>
          <bk-price
              v-else
              :unit-text="showPriceUnit"
              :value="item.payAmtText"
          />

        </bk-view>

      </bk-view>

    </bk-view>

  </bk-view>
</template>

<script>


	export default {
		name: 'e-invoiceOrderInfo',
		components: {},
		props: {
			orderInfo: undefined,
			showPriceUnit: undefined
		},
		data () {

			return {
				// showMoreFlag: true,
				showMoreFlag: false,
				amountInfo: {},
				showPaymentList: [],
			};
		},
		computed: {},
		created () {

			this.initData();

			this.initShowPaymentLis();
		},
		methods: {

			initData () {

				let {orderInfo} = this;

				if (!orderInfo) {
					return;
				}

				if (orderInfo.billType == 'repayment') {
					this.initRepaymentOrder();
					return;
				}

				let that = this;

				orderInfo.taxCalculateFlag = orderInfo.taxCalculate == 'INCLUDE';
				let subtotal = 0, taxes = 0, totalAmt = 0, itemTaxes = 0;

				orderInfo.contentList = [...orderInfo.projectList, ...orderInfo.productList, ...orderInfo.membershipList, ...orderInfo.packagesList, ...orderInfo.giftCardsList, ...orderInfo.eGiftCardsList];

				orderInfo.contentList.map(function (obj) {


					if (!obj.itemsPaymentList || obj.itemsPaymentList.length == 0) {
						subtotal += Number(obj.paymentAmount || 0);
					} else {

						obj.itemsPaymentList.map(function (payObj) {

							if (['ITEM', 'TC'].indexOf(payObj.payMethodCode) == -1 && payObj.memberRightType != 5) { // 5:抵次的礼品卡
								subtotal += Number(payObj.paymentAmount || 0);
								obj.payAmtText = that.$bk_formatPrice(obj.paymentAmount);
							} else {
								obj.dkFlag = true;
								obj.dkText = `${obj.quantity} `;
							}
						});
					}
				});

				(orderInfo.billCostList || []).map(function (obj) {
					if (obj.status == 1) {
						if (obj.type == 0 || obj.type == 2) { // 税
							taxes += Number(obj.amount || 0);
							if (obj.type == 0 && obj.subType == 0) {
								itemTaxes += Number(obj.amount || 0);
							}
						}
						if (obj.type == 1) { // 小费

						}
					}

				});

				let amtTipText;

				if (orderInfo.ttAmount > 0) {
					let list = [];
					if (orderInfo.taxAmount > 0) {
						list.push(`Tax ${this.$bk_getPriceUnitText()}${this.$bk_formatPrice(orderInfo.taxAmount)}`);
					}
					if (orderInfo.tipAmount > 0) {
						list.push(`Tips ${this.$bk_getPriceUnitText()}${this.$bk_formatPrice(orderInfo.tipAmount)}`);
					}

					amtTipText = `(${list.join(', ')})`;
				}

				if (orderInfo.taxCalculateFlag) {
					subtotal -= itemTaxes;
				}

				totalAmt = this.$bk_formatPrice(subtotal + taxes);

				// bkLog.log('orderInfo.contentList:::', orderInfo.contentList);

				let {cartDiscount, cartDiscountAmount, settleDate} = orderInfo;

				if (cartDiscount && (orderInfo.billStatus == 0 || !orderInfo.settleDate)) {
					totalAmt = Number(totalAmt) - Number(cartDiscountAmount || 0);
					totalAmt = this.$bk_formatPrice(totalAmt);
				}

				bkLog.log('合计金额：', totalAmt);

				this.amountInfo = {
					subtotal: this.$bk_formatPrice(subtotal), // 单据合计
					taxes: this.$bk_formatPrice(taxes), // 税费
					totalAmt: totalAmt, // 总合计
					amtTipText
				};
			},

			initRepaymentOrder () {

				let {orderInfo} = this;

				bkLog.log('orderInfo:::', orderInfo);

				let that = this;

				orderInfo.taxCalculateFlag = orderInfo.taxCalculate == 'INCLUDE';
				let subtotal = 0, taxes = 0, totalAmt = 0, itemTaxes = 0;

				orderInfo.contentList = [...orderInfo.repayDetailList];

				orderInfo.contentList.map(function (obj) {
					if (!obj.costType && obj.costType !== 0) {
						subtotal += Number(obj.amount || 0);
					} else {
            taxes += Number(obj.amount || 0);
          }

          obj.payAmtText = `${obj.amount}`;
				});

				let amtTipText;

				if (orderInfo.ttAmount > 0) {
					let list = [];
					if (orderInfo.taxAmount > 0) {
						list.push(`Tax ${this.$bk_getPriceUnitText()}${this.$bk_formatPrice(orderInfo.taxAmount)}`);
					}
					if (orderInfo.tipAmount > 0) {
						list.push(`Tips ${this.$bk_getPriceUnitText()}${this.$bk_formatPrice(orderInfo.tipAmount)}`);
					}

					amtTipText = `(${list.join(', ')})`;
				}

				if (orderInfo.taxCalculateFlag) {
					subtotal -= itemTaxes;
				}

				totalAmt = this.$bk_formatPrice(subtotal + taxes);

				// bkLog.log('orderInfo.contentList:::', orderInfo.contentList);

				let {cartDiscount, cartDiscountAmount, settleDate} = orderInfo;

				if (cartDiscount && (orderInfo.billStatus == 0 || !orderInfo.settleDate)) {
					totalAmt = Number(totalAmt) - Number(cartDiscountAmount || 0);
					totalAmt = this.$bk_formatPrice(totalAmt);
				}

				bkLog.log('合计金额：', totalAmt);

				this.amountInfo = {
					subtotal: this.$bk_formatPrice(subtotal), // 单据合计
					taxes: this.$bk_formatPrice(taxes), // 税费
					totalAmt: orderInfo.realRepayAmount, // 总合计
					amtTipText
				};
			},

			initShowPaymentLis () {
				let {orderInfo} = this;

				if (!orderInfo) {
					return [];
				}

				let that = this;
				let list = [];

				(orderInfo.billPaymentList || []).map(function (obj) {

					obj.icon = that.$bk_Global.defImages.payTypeIcons[obj.payMethodCode];

					obj.showName = that.$bk_getTextWithLangCode(`mase.dict.PM.${obj.payMethodCode}`, false) || obj.payMethodName;

					if (obj.showName && obj.showName.length > 0) {
						obj.sortName = (obj.showName || '').substring(0, 1);
					}

					if (that.$bk_Global.dkPayments.indexOf(obj.payMethodCode) != -1) {
						// dkFlag
						obj.dkFlag = true;

						obj.payTimes = Number(obj.discountTimes || 0) + Number(obj.discountGiftTimes || 0);

					} else {
						obj.payAmtText = that.$bk_formatPrice(obj.paymentAmount);
					}

					list.push({
          ...obj
					});

				});

				bkLog.log('showPaymentList:::', list);

				this.showPaymentList = list;
			},

		}

	};
</script>

<style lang="less">

.view-eInvoiceOrderInfo {
  background: #F8F7F7;
  padding: 16px;
  border-radius: 10px;
  overflow: hidden;

  > .view-title {
    display: flex;
    margin-bottom: 8px;

    > .bk-title {
      flex: 1;
    }

    > .btn-more {
      .fontBloder();
      color: #333;

      &.show {
        color: var(--color-main);
      }
    }
  }

  > .view-baseInfo {
    > .bk-view {
      line-height: 22px;
      margin-bottom: 8px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    > .view-name {
      font-family: MiSans, MiSans;
      .fontBloder();
      font-size: 14px;
      color: #666666;
      line-height: 22px;
    }

    > .view-flex {
      display: flex;

      > .view-orderId {
        flex: 1;
        .fontBloder();
      }

      > .bk-price {
        color: var(--color-main);
      }
    }

    > .view-date {
      font-family: MiSans, MiSans;
      .fontBloder();
      font-size: 14px;
      color: #666666;
      line-height: 22px;
    }
  }

  > .view-content {
    margin-top: 12px;

    > .bk-view {
      padding: 12px 0;
      border-top: 1px dashed #EFE9E5;

      > .bk-view {
        display: flex;
        line-height: 22px;
        padding: 4px 0;

        &.view-total {

          > .bk-price {
            color: var(--color-main);
          }
        }

        > .view-label {
          flex: 1;
          color: #666;
          font-weight: 500 !important;

          > span {
            margin-right: 5px;
          }
        }

        > .bk-price {
          font-weight: 500 !important;
        }
      }
    }

    > .view-saleItems {
      > .view-contentItem {
        display: flex;
        line-height: 22px;
        padding: 4px 0;

        > .view-name {
          flex: 1;
          color: #666;
          font-weight: 500 !important;

          > span {
            margin-right: 5px;
          }
        }

        > .view-priceInfo {
          text-align: right;
          font-size: 14px;
          padding-bottom: 5px;

          > .bk-view {
            margin-bottom: 4px;

            &:last-child {
              margin-bottom: 0;
            }

            .bk-price {
              font-weight: 500 !important;
            }

            &.view-price {
              color: #999;
            }

            &.view-payPrice {

            }
          }
        }
      }
    }


  }
}


</style>